import { useEffect, useState } from "react";
import * as L from "leaflet";
import { CRS } from "leaflet";
import 'leaflet-plugins/layer/tile/Bing'
import { TileConfiguration, TileKey, Tiles } from "../../../../services/map/Tiles";
import { BING_API_KEY } from "@utils/utils";
import { LeafletPixiContext } from "./useLeafletPixi";
import { useTypedSelector } from "@hooks/useTypedSelector";
import logger from "@utils/logger";
import { match } from "ts-pattern";

const log = logger.getLogger("pixi.useTileLayers")

const getTileLayer = (currentTileProvider: TileConfiguration, tileKey: TileKey, map: L.Map) : L.TileLayer => {
    let tileOptions = { ...currentTileProvider.options, id: tileKey }
    let group = currentTileProvider.group
    delete map.options.crs
    return match(group)
        .with("Bing", () => {
            // @ts-ignore
            return new L.bingLayer(BING_API_KEY, tileOptions)
        })
        .with("Яндекс", () => {
            map.options.crs = CRS.EPSG3395
            return new L.TileLayer(currentTileProvider.url, tileOptions)
        })
        .otherwise(() => new L.TileLayer(currentTileProvider.url, tileOptions))
}

export default function (pixiContext: LeafletPixiContext | undefined) {
    const [currentTileLayer, setTileLayer] = useState<L.TileLayer | undefined>()
    const { mapView } = useTypedSelector((state) => state.mapTabSettings)

    useEffect(() => {
        if (pixiContext?.map) {
            let map = pixiContext?.map
            let tileKey = mapView.enabled ? mapView.currentTileProvider as TileKey : "yandexMap"
            log.info("Initialize tile layer", tileKey)
            if (currentTileLayer?.options.id === tileKey) return

            let currentTileProvider = Tiles[tileKey]

            let tileLayer = getTileLayer(currentTileProvider, tileKey, map)

            if (currentTileLayer) map.removeLayer(currentTileLayer)
            setTileLayer(tileLayer)
            map.addLayer(tileLayer)
            tileLayer.bringToBack()
        }
    }, [pixiContext, mapView])
}